import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvCheckListLineModel } from '../../../../../models/aggregates/asv/asv-checklist-line.model';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '..';

@Injectable({
    providedIn: 'root'
  })

  export class AsvChecklistLineService extends BaseApiTemplateService<AsvCheckListLineModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'checklist-lines';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'checklist-lines/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'checklist-lines/backoffice-ep';
        this.httpClient = http;
      }
}